<template>
  <div class="d-flex p-0" :style="skin.navigation_bar.frame">
        <div @click="start" class="py-2 pb-2 px-3 pe-0" style="cursor:pointer;">
            <span :style="skin.navigation_bar.text">{{ translate('home') }}</span>&nbsp;&nbsp; 
        </div>
        <div 
            v-for="(link,index) in navigation"
            v-bind:key="index"
            class="py-2 pb-2 px-0 pe-1"
        >
            &nbsp;<span :style="skin.navigation_bar.text"> | </span>&nbsp;
            <span :style="skin.navigation_bar.text">{{ link.name }}</span>
        </div>
  </div>
</template>

<script>
export default {
    name: "navigation_bar",
    props:["skin","translation","language","navigation"],
    data(){
        return {

        }
    },
    methods:{
        start(){
            this.$store.dispatch('setLobbyView','main');
            let data = this.$store.getters['prematch_2/getLigasArray'];
            data.forEach(liga => {
                this.$root.$emit('uncheck_liga_prematch2',liga.league);
            });
            let check_countries = document.getElementsByClassName('check_country_prematch2');
            [...check_countries].forEach(item=>{
                if(item.checked){
                    item.checked = false;
                }
            });
            this.$store.dispatch('prematch_2/remove_ligas');
            this.$store.dispatch('prematch_2/unsuscribe_all_events');
        },
        translate(text) {
            if (this.$props.translation[text]) {
                return this.$props.translation[text][this.$props.language];
            }
            return text;
        },
    }
}
</script>

<style>

</style>